export var splitCallbackUrl = function (callbackUrl) {
    var path = 'api/orders/current/payment/direct';
    var prefix = '://';
    var CName = callbackUrl.slice(callbackUrl.indexOf(prefix) + prefix.length, callbackUrl.indexOf(path) - 1);
    return {
        CName: CName,
        path: path,
    };
};
export function cardMask(cardNumber) {
    if (!cardNumber) {
        return '';
    }
    return cardNumber
        .split('')
        .reduce(function (acc, char, index) {
        return index % 4 === 0 && index !== 0
            ? "".concat(acc, " ").concat(char)
            : "".concat(acc).concat(char);
    }, '')
        .replaceAll('*', '•');
}
